<template>
  <quick-info-popup
    :id="`${id}-legend-popup`"
    :position="{ x, y }"
    class="chart-legend-popup"
    :width="400"
  >
    <template #title>
      {{ $t("labels.showDiagramLegend") }}
    </template>

    <template #default>
      <chart-legend
        :id="`${id}-legend`"
        :legend="legend"
        :settings="settings"
        @update:short-title="$emit('update:short-title', $event)"
      />
    </template>
  </quick-info-popup>
</template>

<script setup lang="ts">
import QuickInfoPopup from "@core/ui/QuickInfoPopup.vue";
import ChartLegend from "./ChartLegend.vue";

import type { LegendEntry } from "@editor/items/charts/ChartData";
import type { ChartSettings } from "@editor/items/charts/ChartItem";

interface Props {
  id: string;
  legend: { [groupName: string]: LegendEntry[] };
  settings?: Partial<ChartSettings>;
  x?: number;
  y?: number;
}
withDefaults(defineProps<Props>(), {
  settings: () => ({}),
  x: 0,
  y: 0
});

defineEmits<{
  (
    e: "update:short-title",
    value: {
      uid: string;
      title: string;
      shortTitle?: string | undefined;
      type: string;
      id: string | number;
    }
  ): void;
}>();
</script>

<style lang="scss">
.chart-legend-popup {
  background-color: var(--color-background-close);
}
</style>
